// Querys and Mutations
import {
  CREATE,
  UPDATE,
  GET_WITH_PAGINATION,
  DELETE,
  GET_ALL,
  VALIDATE_EXISTS_CUARTA_CATEGORIA
} from '@/graphql/dailyControl/CuartaCategoriaGraphQl'

// models
import { ResponseDefault, Paginator, ResponseCustom } from '@/models'
import {
  CuartaCategoria,
  CuartaCategoriaForm,
  CuartaCategoriaWithPagination,
  FiltersCuartaCategoria
} from '@/models/dailyControl'
// apollo
import { apolloClient } from '@/apollo'
import { getFirstErrorApollo } from '@/utils/apollo'

const filtersDefault: FiltersCuartaCategoria = {
  applyDate: null,
  employee: null,
  registerDate: null
}

class CuartaCategoriaService {
  /**
   * Queries
   */
  async getWithPagination (perPage = 10, page = 1, filters: FiltersCuartaCategoria): Promise<CuartaCategoriaWithPagination> {
    const result = await apolloClient.query({
      query: GET_WITH_PAGINATION,
      variables: {
        page: page,
        perPage: perPage,
        filters: {
          ...filters,
          employee: Number(filters.employee) > 0 ? Number(filters.employee) : null
        }
      }
    })
    const pagination: Paginator = result.data.cuartaCategoriaWithPagination.paginatorInfo
    const data: CuartaCategoria[] = result.data.cuartaCategoriaWithPagination.data
    const response: CuartaCategoriaWithPagination = {
      objects: data,
      pagination: pagination
    }
    return response
  }

  async getAll (filters: FiltersCuartaCategoria = filtersDefault): Promise<CuartaCategoria[]> {
    const result = await apolloClient.query({
        query: GET_ALL,
        variables: {
          filters: {
            ...filters,
            employee: Number(filters.employee) > 0 ? Number(filters.employee) : null
          }
        }
    })
    return result.data.cuartaCategoria
  }

  /**
   * Mutations
   */
  create (form: CuartaCategoriaForm): Promise<ResponseCustom> {
    return apolloClient.mutate({
      mutation: CREATE,
      variables: {
        input: form
      }
    }).then(() => {
      return {
        success: true,
        msg: 'success'
      }
    }).catch(e => {
      throw getFirstErrorApollo(e)
    })
  }

  update (id: number, form: CuartaCategoriaForm): Promise<ResponseCustom> {
    return apolloClient.mutate({
      mutation: UPDATE,
      variables: {
        id: id,
        input: form
      }
    }).then(() => {
      return {
        success: true,
        msg: ''
      }
    }).catch(e => {
      throw getFirstErrorApollo(e)
    })
  }

  async delete (id: number): Promise<ResponseDefault> {
    await apolloClient.mutate({
      mutation: DELETE,
      variables: {
        id: id
      }
    })
    return {
      success: true,
      errors: []
    }
  }

  validateExists (id: number|null, form: CuartaCategoriaForm): Promise<ResponseCustom> {
    return apolloClient.mutate({
      mutation: VALIDATE_EXISTS_CUARTA_CATEGORIA,
      variables: {
        id: id,
        input: form
      }
    }).then(res => {
      return {
        success: res.data.validateCuartaCategoria.success,
        msg: res.data.validateCuartaCategoria.msgError
      }
    }).catch(e => {
      throw getFirstErrorApollo(e)
    })
  }
}

export default new CuartaCategoriaService()
